import { COOKIE_NAME } from '@/config'

const SessionService = {
  getSession () {
    try {
      let data = window.$cookies.get(COOKIE_NAME)

      // Base64 decode
      return JSON.parse(decodeURIComponent(window.atob(data)))
    } catch (e) {
      //
    }
    // In case the cookie is not set or an error ocurred
    return {}
  },

  getToken () {
    let session = this.getSession()
    return session['token']
  },

  getCodigoAccesso () {
    let session = this.getSession()
    return session['codigoAcceso']
  },

  getNombreOperador () {
    let session = this.getSession()
    return session['nombreOperador']
  },

  isLoggedIn () {
    return !!this.getToken()
  }
}

export default SessionService
